import React, { useEffect, useMemo, useState } from "react";
import { Link, useParams } from "react-router-dom";
import {
  Badge,
  Card,
  CardBody,
  UncontrolledTooltip,
} from "reactstrap";
import TableContainer from "../../components/Common/TableContainer";
import EcommerceOrdersPaymentModal from "../../pages/Ecommerce/EcommerceOrders/EcommerceOrdersPaymentModal";


const CorporateCustomerCart = ({ userIds }) => {
  const baseurl = process.env.REACT_APP_BASE_URL;
    const imgurl = process.env.REACT_APP_IMAGE_URL;
  
    const [cartData, setCartData] = useState([]);
    const [pagination, setPagination] = useState({});
    const [loading, setLoading] = useState(true);
    const [paymentDetailsModal, setPaymentDetailsModal] = useState(false);
  
    // 🔹 Fetch Cart Data
    useEffect(() => {
      const fetchCarts = async () => {
        try {
          setLoading(true);
          const res = await fetch(`${baseurl}/admin/customer/individuals/carts/${userIds}`);
          const data = await res.json();
  
          if (data.success) {
            setCartData(data.data);
            setPagination(data.pagination);
          } else {
            setCartData([]);
          }
        } catch (err) {
          console.error("Fetch carts error:", err);
        } finally {
          setLoading(false);
        }
      };
  
      if (userIds) fetchCarts();
    }, [userIds, baseurl]);
  
    // 🔹 Modal toggle
    const togglePaymentDetailsViewModal = () =>
      setPaymentDetailsModal(!paymentDetailsModal);
  
    // 🔹 Define Table Columns
    const columns = useMemo(
      () => [
        {
          Header: "Cart ID",
          accessor: "id",
          disableFilters: true,
          Cell: ({ value }) => <div className="text-body fw-bold">{value}</div>,
        },
        {
          Header: "Cart Number",
          accessor: "cart_no",
          disableFilters: true,
          Cell: ({ value }) => <div className="text-body fw-bold">{value}</div>,
        },
        {
          Header: "Cart Name",
          accessor: "cart_name",
          disableFilters: true,
          Cell: ({ value }) => <div className="text-body">{value}</div>,
        },
        {
          Header: "Status",
          accessor: "status",
          disableFilters: true,
          Cell: ({ value }) => (
            <Badge color={value === "Converted" ? "success" : value === "Active" ? "primary" : "danger"}>
              {value}
            </Badge>
          ),
        },
        {
          Header: "Created Date",
          accessor: "created_at",
          disableFilters: true,
          Cell: ({ value }) =>
            new Date(value).toLocaleString("en-IN", {
              dateStyle: "medium",
              timeStyle: "short",
            }),
        },
        {
          Header: "Updated Date",
          accessor: "updated_at",
          disableFilters: true,
          Cell: ({ value }) =>
            new Date(value).toLocaleString("en-IN", {
              dateStyle: "medium",
              timeStyle: "short",
            }),
        },
        {
          Header: "Action",
          accessor: "action",
          disableFilters: true,
          Cell: ({ row }) => {
            const { cart_no, status } = row.original;
            const isExpired = status === "Expired";
            return (
              <div className="d-flex gap-3 align-items-center">
                {/* <Link
                  to="#"
                  className="text-success"
                  onClick={togglePaymentDetailsViewModal}
                >
                  <i className="mdi mdi-eye-outline font-size-18" id={`view-${cart_no}`} />
                  <UncontrolledTooltip placement="top" target={`view-${cart_no}`}>
                    View Cart
                  </UncontrolledTooltip>
                </Link> */}
  
                <Link
                  to={`/manage-request/cart/individual-customers/cart-list/${cart_no}`}
                  className={`text-success ${isExpired ? "disabled-link" : ""}`}
                  aria-disabled={isExpired}
                >
                  <i className="mdi mdi-pencil font-size-18" id={`edit-${cart_no}`} />
                  <UncontrolledTooltip placement="top" target={`edit-${cart_no}`}>
                    Edit Cart
                  </UncontrolledTooltip>
                </Link>
              </div>
            );
          },
        },
      ],
      []
    );
  
    if (loading)
      return (
        <div className="text-center py-5">
          <div className="spinner-border text-secondary" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      );
  
    return (
      <>
          <h5 className="mb-3">
              Cart List{" "}
              <Badge color="secondary" pill>
                {pagination.total || 0}
              </Badge>
            </h5>
  
            {cartData.length > 0 ? (
              <TableContainer
                columns={columns}
                data={cartData}
                isGlobalFilter={false}
                customPageSize={10}
                className="custom-header-css"
              />
            ) : (
              <p className="text-muted text-center">No cart data available.</p>
            )}
          
  
        <EcommerceOrdersPaymentModal
          isOpen={paymentDetailsModal}
          toggle={togglePaymentDetailsViewModal}
        />
      </>
    );
  };

export default CorporateCustomerCart;
